import { LayoutType } from '@sbercloud/uikit-product-utils';
import cn from 'classnames';

import {
  SectionCatalogProps,
  SectionCatalogSearch,
} from '../../helperComponents';
import { SectionCatalogWithSearch } from '../../helperComponents';
import { SectionCatalogSearchItem } from '../../types';
import styles from './styles.module.scss';

type SectionCatalogMainProps = {
  searchProps?: SectionCatalogSearchItem;
  sectionCatalogProps: SectionCatalogProps;
  layoutType: LayoutType;
  className?: string;
  // Todo: в будущем убрать
  isOldCard?: boolean;
};

export function SectionCatalogMain({
  searchProps,
  sectionCatalogProps,
  layoutType,
  className,
  isOldCard,
  ...rest
}: SectionCatalogMainProps) {
  return (
    <div
      className={styles.body}
      style={{
        // Todo: переделать, когда будет нормальный компоннет от дизайна, сейчас костыль, согласовали с дизайном
        background: isOldCard ? '#EEEFF3' : undefined,
        paddingBottom: isOldCard ? '56px' : undefined,
      }}
    >
      <div
        className={cn(styles.content, className)}
        data-layout-type={layoutType}
      >
        {searchProps && (
          <SectionCatalogSearch
            handleFocusSearch={searchProps.handleFocusSearch}
            handleChangeFilter={searchProps.handleChangeFilter}
            onPlatformFilterChange={searchProps.onPlatformFilterChange}
            titleFilter={searchProps.titleFilter}
            platforms={searchProps.platforms}
            platformFilter={searchProps.platformFilter}
          />
        )}
        <SectionCatalogWithSearch
          id={sectionCatalogProps.id}
          isOldCard={isOldCard}
          title={sectionCatalogProps.title}
          categories={sectionCatalogProps.categories}
          onCategorySelect={sectionCatalogProps.onCategorySelect}
          selectedCategory={sectionCatalogProps.selectedCategory}
          layoutType={sectionCatalogProps.layoutType}
          footer={sectionCatalogProps.footer}
          isSearching={sectionCatalogProps.isSearching}
          bottomContent={sectionCatalogProps.bottomContent}
          onChangeSection={sectionCatalogProps.onChangeSection}
          platformFilter={sectionCatalogProps.platformFilter}
          {...rest}
        />
      </div>
    </div>
  );
}
